export enum RichTextEditorGlobalError {
  RichTextEditorInitializationFailed = 2000,
  ReparseHtmlCalledBeforeInitialization = 2001
}
